import { Pipe, PipeTransform } from '@angular/core';
import { rmaProperties } from '../rmaProperties';

@Pipe({
  name: 'rmaBaseUrl',
  standalone: false,
})
export class RmaBaseUrlPipe implements PipeTransform {
  public transform(value: string): string {
    return new URL(value, rmaProperties.baseUrl).toString();
  }
}
